export default "__VITE_ASSET__17ZQCj3A__"